export default "__VITE_ASSET__b40c0f0a__"